import React, { useEffect, useRef, useState } from "react";
import moment from "moment-timezone";
// import moment from "moment";

const BookingSlider = ({
  bookingsList,
  // handleSlotDate,
  // slotIndex,
  handleTimeSlot,
  slot,
  slotDate,
  index = "",
  handleNoSlot,
  cur = "",
  service,
  weekDate,
  slotResponse,
}) => {
  const elementRef = useRef(null);
  const timeRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(0);
  const [isCompleted, setIsCompleted] = useState(false);
  const myZone = localStorage.getItem("zone");

  const handleHorizontalScroll = (element, speed, distance, step) => {
    let scrollAmount = 0;
    const slideTimer = setInterval(() => {
      element.scrollLeft += step;
      scrollAmount += Math.abs(step);
      if (scrollAmount >= distance) {
        clearInterval(slideTimer);
      }
    }, speed);

    useEffect(() => {
      return () => {
        clearInterval(slideTimer);
      };
    }, []);
  };

  const currentTimeInUTC = moment().format("YYYY-MM-DDTHH:mm:ss[Z]");

  useEffect(() => {
    let count = 0;
    setLoading(true);

    if (bookingsList) {
      bookingsList.forEach((item) => {
        const { startTime, endTime } = item;
        const currentTime = new Date().getTime();
        const startTimeInMillis = new Date(startTime).getTime();
        const isValid = startTimeInMillis > currentTime;
        if (isValid) {
          count += 1;
        }
      });

      setCount(count);
    }
    setLoading(false);
  }, [bookingsList, slotDate]);

  // const handleCountChange = (val) => {
  //   if (val && count === 0) {
  //     console.log("I", slotDate);
  //     handleNoSlot(true, index, slotDate);
  //   }
  // };

  // return slotResponse.loading ? (
  //   <p>Fetching time slots...</p>
  // ) : slotResponse.error ? (
  //   <p>Error fetching time slot</p>
  // ) : (

  return (
    <div className="mt-3">
      {loading ? (
        <p>Loading</p>
      ) : bookingsList === undefined ? (
        <p>No slots available for the picked date</p>
      ) : bookingsList.length === 0 ? (
        <p>No slots available for the picked date</p>
      ) : (
        <>
          <p>
            Slots for{" "}
            {service === "Single session"
              ? moment(slotDate).format("DD-MM-YYYY")
              : weekDate}
          </p>
          <div className="d-flex booking-scroll-card justify-content-center">
            {count > 3 && (
              <button
                className="btn rotate-deg"
                onClick={() => {
                  handleHorizontalScroll(timeRef.current, 25, 100, -10);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M6.64131 16.2749C6.41942 16.0531 6.39925 15.7058 6.5808 15.4612L6.64131 15.3911L12.0324 9.99967L6.64131 4.60828C6.41942 4.38639 6.39925 4.03917 6.58079 3.7945L6.64131 3.7244C6.8632 3.50251 7.21042 3.48234 7.45509 3.66388L7.52519 3.7244L13.3585 9.55773C13.5804 9.77962 13.6006 10.1268 13.419 10.3715L13.3585 10.4416L7.52519 16.2749C7.28112 16.519 6.88539 16.519 6.64131 16.2749Z"
                    fill="black"
                    fillOpacity="0.6"
                  />
                </svg>
              </button>
            )}
            <div className="d-flex booking-card" ref={timeRef}>
              {bookingsList.map((item) => {
                const { startTime, endTime, utcStartTime } = item;
                const currentTime = moment.utc().toISOString();
                const isValid = moment(utcStartTime).isAfter(
                  moment.utc(currentTime)
                );
                if (isValid) {
                  return (
                    <div
                      className={
                        slot !== null &&
                        slot.time !== null &&
                        slot.time.startTime === item.startTime
                          ? "date-card active-date-card"
                          : "date-card"
                      }
                      onClick={() => handleTimeSlot(item, index)}
                    >
                      <div className="card-body p-3">
                        <p className="text-center days-txt mb-0">
                          {/* {moment(startTime).tz(myZone).format("h:mm A")} -{" "}
                          {moment(endTime).tz(myZone).format("h:mm A")} */}
                          {moment.utc(startTime).format("h:mm A")} -{" "}
                          {moment.utc(endTime).format("h:mm A")}
                        </p>
                      </div>
                    </div>
                  );
                } else {
                  // Return null for past times
                  return null;
                }
              })}
            </div>
            {count > 3 && (
              <button
                className="btn"
                onClick={() => {
                  handleHorizontalScroll(timeRef.current, 25, 100, 10);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M6.64131 16.2749C6.41942 16.0531 6.39925 15.7058 6.5808 15.4612L6.64131 15.3911L12.0324 9.99967L6.64131 4.60828C6.41942 4.38639 6.39925 4.03917 6.58079 3.7945L6.64131 3.7244C6.8632 3.50251 7.21042 3.48234 7.45509 3.66388L7.52519 3.7244L13.3585 9.55773C13.5804 9.77962 13.6006 10.1268 13.419 10.3715L13.3585 10.4416L7.52519 16.2749C7.28112 16.519 6.88539 16.519 6.64131 16.2749Z"
                    fill="black"
                    fillOpacity="0.6"
                  />
                </svg>
              </button>
            )}
          </div>
        </>
      )}
      {/* )} */}
    </div>
  );
};

export default BookingSlider;
